"use client";

import { useEffect, useRef, useState } from "react";
import AppImage from "@/components/ui/AppImage";

const testimonials = [
{
  name: "Priya S.",
  from: "B.Tech Graduate → University of Toronto",
  course: "University of Toronto",
  year: "Canada 🇨🇦",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e03fecaf-1763301929081.png",
  avatarAlt: "Young Indian woman with confident smile, university student",
  quote: "I'd spent months trying to figure out Canada on my own. In one session with GlobalVarsity, I had a clearer plan than I'd managed in six months. Got into my first-choice university in Toronto with a partial scholarship. Still can't believe it.",
  flag: "🇨🇦",
  rating: 5
},
{
  name: "Rohan M.",
  from: "MBA Aspirant → University of Newcastle",
  course: "University of Newcastle",
  year: "Australia 🇦🇺",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ccf84a23-1763296755798.png",
  avatarAlt: "Young Indian man smiling, MBA student",
  quote: "My visa was rejected once before I came to GlobalVarsity. They went through everything — my documents, my finances, my interview answers. Second time? Approved in 12 days. The difference was night and day.",
  flag: "🇦🇺",
  rating: 5
},
{
  name: "Ananya K.",
  from: "Engineering Student → TU Munich",
  course: "TU Munich",
  year: "Germany 🇩🇪",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d0f31e59-1772804174565.png",
  avatarAlt: "Young Indian woman engineer, professional headshot",
  quote: "I was nervous about Germany because of the language barrier and the blocked account process. Global Varsity made it feel manageable — step by step. I\'m now in my second year at TUM Munich and I couldn\'t be happier.",
  flag: "🇩🇪",
  rating: 5
},
{
  name: "Vikram P.",
  from: "Parent of a Student → University of Edinburgh",
  course: "University of Edinburgh",
  year: "United Kingdom 🇬🇧",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb20a87b-1775892878008.png",
  avatarAlt: "Indian professional man, parent of international student",
  quote: "What I appreciated most was their honesty. They told me one of the universities I wanted wasn\'t the right fit — and suggested a better option I hadn\'t considered. That kind of advice is rare. It\'s also the reason I trust them completely.",
  flag: "🇬🇧",
  rating: 5
},
{
  name: "Meera L.",
  from: "Arts Graduate → University College Dublin",
  course: "University College Dublin",
  year: "Ireland 🇮🇪",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17a1f455f-1763296936452.png",
  avatarAlt: "Young Indian woman with bright smile, international student",
  quote: "The SOP they helped me write was completely different from what I had. It actually told my story — not just a list of my achievements. I got into three of my five choices. I'm still shocked.",
  flag: "🇮🇪",
  rating: 5
},
{
  name: "Arjun T.",
  from: "Computer Science Graduate → University of Auckland",
  course: "University of Auckland",
  year: "New Zealand 🇳🇿",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19dc0de1c-1763299821348.png",
  avatarAlt: "Young Indian man, computer science student abroad",
  quote: "I had no idea New Zealand was such a great option for tech. Global Varsity opened my eyes to it and handled everything — from shortlisting universities to getting my visa sorted. Best decision I ever made.",
  flag: "🇳🇿",
  rating: 5
},
{
  name: "Sneha R.",
  from: "Nursing Graduate → University of Manchester",
  course: "University of Manchester",
  year: "United Kingdom 🇬🇧",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a620b6fa-1772408652577.png",
  avatarAlt: "Young Indian woman, nursing student in the UK",
  quote: "The team at Global Varsity understood exactly what I needed for a healthcare program in the UK. They guided me through every document, every requirement. I'm now at Manchester and loving every moment of it.",
  flag: "🇬🇧",
  rating: 5
},
{
  name: "Karan B.",
  from: "Business Graduate → Monash University",
  course: "Monash University",
  year: "Australia 🇦🇺",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c745c1d8-1763296357030.png",
  avatarAlt: "Young Indian man, business student in Australia",
  quote: "From shortlisting universities to getting my student visa, Global Varsity was with me at every step. They even helped me find accommodation before I landed. I felt prepared and confident the entire time.",
  flag: "🇦🇺",
  rating: 5
},
{
  name: "Divya N.",
  from: "Science Graduate → University of British Columbia",
  course: "University of British Columbia",
  year: "Canada 🇨🇦",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16b272e06-1763297463447.png",
  avatarAlt: "Young Indian woman, science student in Canada",
  quote: "I was overwhelmed by the whole process — tests, documents, deadlines. Global Varsity broke it all down into simple steps. I got into UBC with a merit scholarship. I still recommend them to every student I meet.",
  flag: "🇨🇦",
  rating: 5
},
{
  name: "Rahul S.",
  from: "Commerce Graduate → University of Amsterdam",
  course: "University of Amsterdam",
  year: "Netherlands 🇳🇱",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12ea075c2-1763300507102.png",
  avatarAlt: "Young Indian man, finance student in the Netherlands",
  quote: "GlobalVarsity helped me explore options I hadn't even considered. The Netherlands turned out to be the perfect fit — affordable, English-taught programs, and a great career scene. Couldn't have found this path without them.",
  flag: "🇳🇱",
  rating: 5
},
{
  name: "Pooja V.",
  from: "Psychology Graduate → University of Melbourne",
  course: "University of Melbourne",
  year: "Australia 🇦🇺",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1613c5d3c-1763294680610.png",
  avatarAlt: "Young Indian woman, psychology student in Australia",
  quote: "The counsellors at GlobalVarsity genuinely cared about my goals, not just getting me enrolled somewhere. They matched me with the right program at Melbourne and my visa came through without a single issue.",
  flag: "🇦🇺",
  rating: 5
},
{
  name: "Nikhil A.",
  from: "IT Graduate → University of Waterloo",
  course: "University of Waterloo",
  year: "Canada 🇨🇦",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10120f91e-1763301853398.png",
  avatarAlt: "Young Indian man, IT student in Canada",
  quote: "I had a complicated academic background and wasn\'t sure any top university would accept me. GlobalVarsity helped me present my profile in the best light. I\'m now at Waterloo — one of the best tech schools in the world.",
  flag: "🇨🇦",
  rating: 5
},
{
  name: "Simran K.",
  from: "Design Graduate → Politecnico di Milano",
  course: "Politecnico di Milano",
  year: "Italy 🇮🇹",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103f96a37-1763300628475.png",
  avatarAlt: "Young Indian woman, design student in Italy",
  quote: "Studying design in Italy felt like a dream too far. GlobalVarsity made it real — from portfolio guidance to visa prep. I\'m now studying at one of the world\'s top design schools and it still feels surreal.",
  flag: "🇮🇹",
  rating: 5
},
{
  name: "Aditya R.",
  from: "Engineering Graduate → ETH Zurich",
  course: "ETH Zurich",
  year: "Switzerland 🇨🇭",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16972ee40-1773120700276.png",
  avatarAlt: "Young Indian man, engineering student in Switzerland",
  quote: "ETH Zurich was always my dream but I thought it was out of reach. GlobalVarsity helped me build a strong application, prep for the requirements, and navigate the Swiss student visa process. I made it — and I'm thriving.",
  flag: "🇨🇭",
  rating: 5
}];



export default function TestimonialsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    ref?.current?.querySelectorAll(".reveal, .reveal-scale")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  const visible = [
  testimonials?.[current],
  testimonials?.[(current + 1) % testimonials?.length],
  testimonials?.[(current + 2) % testimonials?.length]];


  return (
    <section id="testimonials" ref={ref} className="py-28 px-6 lg:px-10 dot-pattern">
      <div className="max-w-site mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="reveal flex justify-center mb-4">
            <span className="section-label">Real Students. Real Results.</span>
          </div>
          <h2
            className="font-serif reveal delay-1 mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
            
            Don't Take Our Word for It.{" "}
            <span className="gradient-text italic">Take Theirs.</span>
          </h2>
          <p className="text-ink-muted text-lg max-w-xl mx-auto reveal delay-2">
            500+ students trusted us with their most important decision. Here's what they say.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {visible?.map((t, i) =>
          <div
            key={`${t?.name}-${current}-${i}`}
            className={`reveal delay-${i + 1} testimonial-card bg-white rounded-card p-6 border border-crimson-100 shadow-soft`}>
            
              {/* Quote */}
              <div className="text-3xl text-crimson/20 font-serif leading-none mb-3">"</div>
              <p className="text-sm text-ink leading-relaxed mb-6" style={{ fontWeight: 400 }}>
                {t?.quote}
              </p>

              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t?.rating })?.map((_, j) =>
              <span key={j} className="text-gold text-sm">★</span>
              )}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-crimson-50">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border-2 border-crimson/20">
                  <AppImage
                  src={t?.avatar}
                  alt={t?.avatarAlt}
                  width={40}
                  height={40}
                  className="w-full h-full object-cover" />
                
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-ink text-sm truncate">{t?.name}</p>
                  <p className="text-xs text-ink-muted truncate">{t?.from}</p>
                </div>
                <span className="text-xl flex-shrink-0">{t?.flag}</span>
              </div>

              <div className="mt-3 flex gap-2 flex-wrap">
                <span className="text-xs bg-parchment border border-crimson-50 text-ink-muted px-2.5 py-1 rounded-full">
                  {t?.course}
                </span>
                <span className="text-xs bg-crimson/8 text-crimson px-2.5 py-1 rounded-full font-medium">
                  {t?.year}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-center gap-3 reveal delay-3">
          <button
            onClick={() => setCurrent((c) => (c - 1 + testimonials?.length) % testimonials?.length)}
            className="w-10 h-10 rounded-full border border-crimson/20 flex items-center justify-center text-crimson hover:bg-crimson hover:text-white transition-all"
            aria-label="Previous testimonials">
            
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="flex gap-2">
            {testimonials?.map((_, i) =>
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`rounded-full transition-all duration-300 ${
              i === current ? "w-6 h-2 bg-crimson" : "w-2 h-2 bg-crimson/20 hover:bg-crimson/50"}`
              }
              aria-label={`Go to testimonial ${i + 1}`} />

            )}
          </div>
          <button
            onClick={() => setCurrent((c) => (c + 1) % testimonials?.length)}
            className="w-10 h-10 rounded-full border border-crimson/20 flex items-center justify-center text-crimson hover:bg-crimson hover:text-white transition-all"
            aria-label="Next testimonials">
            
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        {/* CTA */}
        <div className="text-center mt-10 reveal delay-4">
          <a href="#contact" className="btn-primary">
            Join the Next Success Story — Book Free Session
          </a>
        </div>
      </div>
    </section>);

}